import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const EASE = [0.22, 1, 0.36, 1];

export const Testimonials = () => {
  const { content, t, lang } = useSite();

  return (
    <section id="praise" data-testid="testimonials-section" className="py-32 bg-slate-900 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-sky-500/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-orange-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="max-w-2xl"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-orange-400">
            {lang === "zh" ? "客户表扬" : "Client Praise"}
          </p>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-white">
            {lang === "zh" ? "他们这样说我们" : "Kind Words From Clients"}
          </h2>
        </motion.div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {content.testimonials.map((tst, i) => (
            <motion.blockquote
              key={tst.id || i}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
              className={`rounded-3xl bg-white/[0.06] backdrop-blur-sm border border-white/10 p-8 hover:bg-white/[0.1] transition-[background-color] duration-400 ${i === 1 ? "md:-translate-y-6" : ""}`}
            >
              <Quote size={28} className="text-orange-400" />
              <p className="mt-5 text-base leading-relaxed text-slate-200">{t(tst, "quote")}</p>
              <div className="mt-6 flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="fill-orange-400 text-orange-400" />
                ))}
              </div>
              <footer className="mt-6 flex items-center gap-4">
                <img
                  src={tst.avatar}
                  alt={t(tst, "name")}
                  loading="lazy"
                  className="w-12 h-12 rounded-full object-cover border-2 border-sky-400"
                />
                <div>
                  <p className="font-bold text-white text-sm">{t(tst, "name")}</p>
                  <p className="text-xs text-slate-400">{t(tst, "role")}</p>
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
